export default "__VITE_ASSET__B$R2nCYA__"